// extracted by mini-css-extract-plugin
export default {"arrow":"ForwardArrow_arrow__zyISL","arrowRtl":"ForwardArrow_arrowRtl__7iJFp"};